import { render, staticRenderFns } from "./FinalizacaoAprovarDialog.vue?vue&type=template&id=628a5d30"
import script from "./FinalizacaoAprovarDialog.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAprovarDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports